module.exports = {
    'GeneratePagination': require('./generatePagination')
};